import type { Rule } from "../../../../../../shared/frontend/ui";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

export const MINIMUM_DATE_OF_BIRTH = dayjs("1900-01-01");

export function dateOfBirthFieldContract(
  text: (key: "PersonDateOfBirthInvalid") => string,
  today: Dayjs = dayjs(),
): { minDate: Dayjs; maxDate: Dayjs; rules: Rule[] } {
  const maximumDate = today.endOf("day");
  return {
    minDate: MINIMUM_DATE_OF_BIRTH,
    maxDate: maximumDate,
    rules: [{
      validator: async (_, value: Dayjs | null | undefined) => {
        if (value == null) return;
        if (
          !dayjs.isDayjs(value)
          || !value.isValid()
          || value.isBefore(MINIMUM_DATE_OF_BIRTH, "day")
          || value.isAfter(maximumDate, "day")
        ) {
          throw new Error(text("PersonDateOfBirthInvalid"));
        }
      }
    }]
  };
}
